import { variables } from "politicamente-informados-ds";
import styled from "styled-components";

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 600px) {
    align-items: center;
    justify-content: center;
    > {
      text-align: center;
    }
  }

  background-color: ${variables.colors.gray100};
  color: white;
  padding: 6rem 2rem;
  transition: all 300ms;
  a {
    cursor: pointer;
    color: white;
    transition: all 300ms;
    img {
      cursor: pointer;
    }
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const StyledLinks = styled.div`
  display: flex;
  gap: 16px;
  color: white;
`;
